import { Trans } from '@lingui/macro'
import { MAX_WIDTH_MEDIA_BREAKPOINT, MEDIUM_MEDIA_BREAKPOINT } from 'components/Tokens/constants'
import { MouseoverTooltip } from 'components/Tooltip'
import React, { useState } from 'react'
import styled from 'styled-components/macro'
import { ThemedText } from 'theme'

import FarmTable from './FarmTable'
import { Checkbox } from '../../nft/components/layout/Checkbox'
import { Box } from 'rebass/styled-components'

const ExploreContainer = styled.div`
  width: 100%;
  min-width: 320px;
  padding: 68px 12px 0;

  @media only screen and (max-width: ${({ theme }) => `${theme.breakpoint.md}px`}) {
    padding-top: 48px;
  }

  @media only screen and (max-width: ${({ theme }) => `${theme.breakpoint.sm}px`}) {
    padding-top: 20px;
  }
`
const TitleContainer = styled.div`
  margin-bottom: 32px;
  max-width: ${MAX_WIDTH_MEDIA_BREAKPOINT};
  margin-left: auto;
  margin-right: auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  @media only screen and (max-width: ${MEDIUM_MEDIA_BREAKPOINT}) {
    flex-direction: column;
    align-items: stretch;
  }
`
const FiltersContainer = styled.div`
  display: flex;
  gap: 8px;
  height: 40px;

  @media only screen and (max-width: ${MEDIUM_MEDIA_BREAKPOINT}) {
    order: 2;
  }
`
const SearchContainer = styled(FiltersContainer)`
  margin: 0;
  width: auto;
  justify-content: flex-end;

  @media only screen and (max-width: ${MEDIUM_MEDIA_BREAKPOINT}) {
    margin: 0;
    margin-top: 20px;
    order: 1;
  }
`

const Farm = () => {
  const [hideInactive, setHideInactive] = useState(true)
  const handleCheckbox = (v: any) => {
    setHideInactive((v) => !v)
  }
  return (
    <ExploreContainer>
      <TitleContainer>
        <MouseoverTooltip text={<Trans>This table contains all V3 farms.</Trans>} placement="bottom">
          <ThemedText.LargeHeader>
            <Trans>Farms</Trans>
          </ThemedText.LargeHeader>
        </MouseoverTooltip>
        <Checkbox hovered={true} checked={hideInactive} onChange={handleCheckbox} width="100%">
          <div style={{ marginRight: '10px' }}>
            <Box as="div" color="textTertiary" paddingRight="12" marginRight="12">
              Hide ended
            </Box>
          </div>
        </Checkbox>
      </TitleContainer>

      <FarmTable hideInactive={hideInactive} />
    </ExploreContainer>
  )
}

export default Farm
